var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 283.022,
    height: 220.974,
    viewBox: "0 0 283.022 220.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6c63ff;}.a,.h{opacity:0.1;}.b{fill:none;stroke:#535461;stroke-miterlimit:10;stroke-width:2px;}.c{fill:#c5c9d3;}.d{fill:url(#a);}.e{fill:#e6e6e6;}.f{fill:#dde1ec;}.g,.i{fill:#535461;}.g{opacity:0.3;}.j{fill:url(#b);}.k{fill:#b26bab;}.l{fill:#d9d9d9;}.m{fill:#7e59f2;}.n{fill:#bab8dd;}.o{opacity:0.05;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y2: 0,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.007 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M110.956,85.989c-1.848.767-3.745,1.751-4.761,3.476-1.076,1.823-.947,4.086-.747,6.195,1.745,18.289,6.343,37.74-1.6,54.306C100,158,93.552,164.444,88.424,171.743s-9,16.412-6.618,25c2.907,10.492,13.757,16.309,21.07,24.384,4.787,5.279,8.143,11.694,12.609,17.248s10.587,10.446,17.717,10.773c10.255.472,18.6-8.383,28.652-10.435,10.3-2.1,20.672,3.245,29.024,9.642s15.949,14.149,25.68,18.143c10.747,4.415,22.861,3.74,34.175,6.392,10.3,2.418,19.783,7.559,30.009,10.3s22.212,2.575,30.135-4.426c10.326-9.156,9.514-25.465,16.109-37.577,6.126-11.253,18.117-17.971,26.189-27.92,14.524-17.906,14.049-45.273,1.717-64.747s-34.67-31.265-57.511-34.335c-10.3-1.382-20.907-1.193-30.81-4.338-26.507-8.412-42.281-38.552-69.342-44.824-17.2-3.98-33.931,2.913-48.584,11.4C135.926,83.783,124.193,80.5,110.956,85.989Z",
    transform: "translate(-81.08 -63.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.691,347.69s-9.765,9.216-20.246,9.491a20.34,20.34,0,0,0-12.123,4.312,34.216,34.216,0,0,0-4.532,4.312",
    transform: "translate(-127.984 -266.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M119.364,410.8c1.408-.715,6.781-.24,6.781-.24s-2.787,4.621-4.195,5.336a2.861,2.861,0,1,1-2.575-5.1Z",
    transform: "translate(-107.168 -311.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M135.9,383.227c1.571.166,5.823,3.485,5.823,3.485s-4.864,2.363-6.421,2.2a2.861,2.861,0,0,1,.6-5.685Z",
    transform: "translate(-118.042 -291.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M179.242,359.031c1.27.936,3.268,5.948,3.268,5.948s-5.382-.409-6.652-1.342a2.861,2.861,0,0,1,3.385-4.607Z",
    transform: "translate(-147.975 -274.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M219.066,349.889c1.411.707,4.226,5.31,4.226,5.31s-5.373.506-6.784-.2a2.861,2.861,0,1,1,2.558-5.11Z",
    transform: "translate(-176.528 -267.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M160.21,396.847c.469-1.508-.9-6.727-.9-6.727s-4.086,3.525-4.555,5.033a2.861,2.861,0,1,0,5.459,1.694Z",
    transform: "translate(-133.544 -296.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M205.927,386.666c0-1.579-2.876-6.146-2.876-6.146s-2.844,4.578-2.841,6.163a2.861,2.861,0,0,0,5.722-.017Z",
    transform: "translate(-166.119 -289.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M249.165,368.314c.263-1.557-1.8-6.544-1.8-6.544s-3.579,4.04-3.84,5.6a2.861,2.861,0,0,0,5.637.95Z",
    transform: "translate(-197.028 -276.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M248.765,188.675S237,182.214,233.506,172.317a20.341,20.341,0,0,0-7.831-10.212,34.213,34.213,0,0,0-5.505-2.976",
    transform: "translate(-180.368 -131.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M200.421,135.516c1.113,1.119,2.312,6.381,2.312,6.381s-5.253-1.23-6.366-2.352a2.861,2.861,0,0,1,4.054-4.029Z",
    transform: "translate(-162.85 -114.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M231.443,141.418c.326,1.545-1.525,6.612-1.525,6.612s-3.74-3.888-4.066-5.436a2.861,2.861,0,1,1,5.594-1.179Z",
    transform: "translate(-184.359 -117.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M268.1,175.6c-.5,1.5-4.655,4.938-4.655,4.938s-1.265-5.245-.767-6.744a2.864,2.864,0,1,1,5.436,1.805Z",
    transform: "translate(-210.632 -140.936)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M288.855,210.992c-.237,1.559-3.754,5.654-3.754,5.654s-2.134-4.956-1.9-6.515a2.861,2.861,0,1,1,5.651.858Z",
    transform: "translate(-225.353 -166.442)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M218.939,171.807c1.579-.017,6.123-2.93,6.123-2.93s-4.609-2.8-6.189-2.787a2.861,2.861,0,0,0,.066,5.722Z",
    transform: "translate(-177.423 -136.836)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M241.714,212.378c1.5-.489,4.964-4.627,4.964-4.627s-5.239-1.3-6.738-.807a2.861,2.861,0,1,0,1.774,5.436Z",
    transform: "translate(-192.999 -165.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M272.65,247.721c1.562-.229,5.677-3.72,5.677-3.72s-4.944-2.163-6.5-1.934a2.861,2.861,0,1,0,.83,5.657Z",
    transform: "translate(-215.409 -191.063)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 103.577,
    cy: 103.577,
    r: 103.577,
    transform: "translate(45.768 6.415)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 101.86,
    cy: 101.86,
    r: 101.86,
    transform: "translate(47.484 8.132)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 80.973,
    cy: 80.973,
    r: 80.973,
    transform: "translate(68.372 29.019)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 4.578,
    height: 71.531,
    rx: 2,
    transform: "translate(147.056 43.325)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(105.9 86.865)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.664,
    height: 5.722,
    rx: 2.861,
    transform: "translate(48.309 21.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.722,
    height: 45.929,
    rx: 2.861,
    transform: "translate(0 5.069) rotate(-62.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.584,
    cy: 8.584,
    r: 8.584,
    transform: "translate(34.861 15.687)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 64.664,
    height: 5.722,
    rx: 2.861,
    transform: "translate(154.209 107.131)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 45.929,
    height: 5.722,
    rx: 2.861,
    transform: "translate(108.575 85.727) rotate(27.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 8.584,
    cy: 8.584,
    r: 8.584,
    transform: "translate(140.761 101.408)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(68.366 29.019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.295,255.971a80.979,80.979,0,0,1,145.683-48.687A80.981,80.981,0,1,0,336.272,294.93a80.6,80.6,0,0,1-9.977-38.959Z",
    transform: "translate(-320 -165.27)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M698.476,196.665c-.961-.924-9.053,5.15-9.053,5.15s-2.881.526-2.195,2.5-3.019,13.05-3.019,13.05L682.7,215.26a9.052,9.052,0,0,0-1.2-5.322c-.054-.089-.109-.175-.163-.255l.263-.092c-.1-1.351-2.26-3.408-3.408-4.415v-.435c.072-1.614.718-3.316,0-4.778-.812-1.668-3.19-2.506-3.391-4.338-.12-1.093.618-2.08.944-3.133.778-2.518-.838-5.087-2.383-7.256a10.15,10.15,0,0,0-1.891-2.18,9.178,9.178,0,0,0-2.272-1.213,58.094,58.094,0,0,0-6.913-2,11.01,11.01,0,0,0-6.581-.132,3.236,3.236,0,0,0-1.431.821,8.857,8.857,0,0,0-.967,2.195,7.822,7.822,0,0,1-2.9,2.607c-1.09.747-2.183,1.771-2.189,3.059,0,1.828,2.089,2.979,2.787,4.681.652,1.585,0,3.35-.363,5.021a3.373,3.373,0,0,0-.043,1.657,3.559,3.559,0,0,0,.641,1.116c.432.572.9,1.1,1.356,1.648l-.212.083c-3.84-.395-6.309,4.481-6.309,4.481.177.037.346.08.512.129l-.163.212a20.818,20.818,0,0,0-2.818,4.93l-3.147,4.217s-.687-10.547.961-12.918-1.508-3.823-1.508-3.823-6.867-7.645-7.82-6.987,2.332,8.964,5.213,10.283a12.665,12.665,0,0,1-.286,4.349c-.346,1.084-2.195,12.524-2.195,12.524s-1.645,9.622,5.9,4.864c4.9-3.084,8.069-8.395,9.682-11.731q.169-.352.318-.672a8.076,8.076,0,0,1,.152,1.073l.286,11.024a16.732,16.732,0,0,1-1.734,7.874l-3.362,6.818.375.114-.226.326c-2.215,3.259-5.98,10.587,1.771,14.32l10.3,1.319-.549,2.635s-4.252,8.04-5.488,13.577a40.681,40.681,0,0,1-3.568,9.754l.318.169c-.066.074-.135.152-.2.232a4.972,4.972,0,0,0-1.19,2.495l-1.4,1.98s-.549,8.172.549,10.152c.6,1.082,2.6,1.768,4.292,2.169a2.826,2.826,0,0,0,3.213-4.146l-.017-.029h-.026c-.286-1.33-1.162-5.459-.876-7.027.08-.446.154-.89.192-1.342a4.743,4.743,0,0,1,.532-1.7c.046-.089.094-.174.143-.26l.149.063c.461.2.916.383,1.348.547-.669.609-1.145,1.871-.572,4.466,0,0,.054,6.492.549,7.514s6.034,2.372,7,1.319-.618-4.681-.618-4.681l-.049.034c-.318-2.1-.71-5.868.255-7.35.389-.6.767-1.216,1.1-1.794l.209-.358h0c1.791.893,3.685,1.565,4.721,1.1,0,0,4.526-10.547,4.252-11.863s7-16.215,7-16.215,6.172-6.867-1.371-11.6c-2.395-1.508-4.14-2.521-5.408-3.2l-1.062-5.551a20.291,20.291,0,0,1,.286-8.773l1.144-4.366h0l.095-.372s2.881-5.931,2.744-8.7a2,2,0,0,1,.072-.638q.047.2.1.412a53.2,53.2,0,0,0,2.981,8.4c2.189,4.938,5.436,4.546,7.216,3.845a2.464,2.464,0,0,0,1.519-1.78c.641-3.073,2.4-11.682,2.512-14.06a40.013,40.013,0,0,1,.687-5.537C695.6,202.2,699.437,197.589,698.476,196.665Z",
    transform: "translate(-474.316 -146.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M725.33,531.719s-.6,1.21-1.431,2.664c-.323.572-.684,1.187-1.053,1.78-1.308,2.091,0,8.755,0,8.755l-2.861.392-2.861-1.431-.524-4.836v-3.536l3.262-3.648,1.431-1.579Z",
    transform: "translate(-534.758 -396.823)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(185.099 133.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.454,531.719s-.6,1.21-1.431,2.664a35.427,35.427,0,0,1-3.657-2.249l-.252-.177-.135-.1,1.431-1.579Z",
    transform: "translate(-727.98 -530.28)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M737.948,403.567s-6.927,14.767-6.664,16.074-4.052,11.763-4.052,11.763c-.984.464-2.792-.2-4.5-1.087a35.255,35.255,0,0,1-3.72-2.289l-.252-.177-.152-.109,11.371-31.5-10.06-7.379-.744-.547L714.68,385l13.734,2.484s.478-.06,3,1.353c1.213.678,2.9,1.694,5.227,3.222C743.825,396.771,737.948,403.567,737.948,403.567Z",
    transform: "translate(-533.387 -293.111)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M716.291,544.406s-3.4-.524-2.22,4.967c0,0,.052,6.438.524,7.439s5.751,2.352,6.664,1.308-.589-4.638-.589-4.638-3.854,2.81-4.9-.2S716.291,544.406,716.291,544.406Z",
    transform: "translate(-532.774 -406.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M694.66,534.279a4.121,4.121,0,0,0-.89,1.236,4.839,4.839,0,0,0-.506,1.682c-.034.446-.106.89-.18,1.331-.326,1.863.924,7.382.924,7.382l-4.967.784-1.828-1.96-.392-4.312a15.622,15.622,0,0,0,.784-4.578,4.8,4.8,0,0,1,1.144-2.861,7.872,7.872,0,0,1,1.325-1.313S695.707,533.364,694.66,534.279Z",
    transform: "translate(-513.498 -397.815)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(175.262 133.849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.5,534.265a4.118,4.118,0,0,0-.89,1.236c-2.034-.919-4.172-2.077-4.95-2.507l-.06-.031a7.876,7.876,0,0,1,1.325-1.313S700.547,533.35,699.5,534.265Z",
    transform: "translate(-693.6 -531.65)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M702.6,399.647s-3.265,6.143-5.359,11.239c-1.373,3.348-4.212,11.319-6.009,16.395l-.263.75c-.79,2.246-1.316,3.765-1.316,3.765a3.4,3.4,0,0,1-1.027-.152c-.309-.083-.655-.195-1.024-.332l-.415-.157c-.412-.16-.858-.346-1.285-.541-2.077-.927-4.292-2.134-5.1-2.575l-.3-.169a41.336,41.336,0,0,0,3.408-9.68c1.176-5.488,5.227-13.448,5.227-13.448l.524-2.615-9.8-1.308c-7.385-3.691-3.8-10.967-1.688-14.2A19.081,19.081,0,0,1,679.333,385l7.843,1.717s1.236.395,3.983,1.611l1.262.572c1.539.707,3.434,1.617,5.723,2.784C705.862,395.587,702.6,399.647,702.6,399.647Z",
    transform: "translate(-505.359 -293.111)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M692.321,554.792a2.775,2.775,0,0,1-3.062,4.109c-1.605-.4-3.508-1.079-4.08-2.152-1.044-1.96-.523-10.063-.523-10.063l1.373-2.026s-.718,8.953.982,9.728,5.293.363,5.293.363Z",
    transform: "translate(-511.861 -407.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M698.819,181.748a3.055,3.055,0,0,0-1.373.815,9.421,9.421,0,0,0-.921,2.177,7.5,7.5,0,0,1-2.758,2.575,4.1,4.1,0,0,0-2.086,3.033c0,1.814,2,2.953,2.655,4.638.621,1.574,0,3.322-.346,4.979a3.474,3.474,0,0,0-.04,1.642,3.567,3.567,0,0,0,.612,1.107c1.262,1.717,2.83,3.239,3.674,5.193a16.078,16.078,0,0,1,.987,4.735,23.8,23.8,0,0,1,.046,6.967.7.7,0,0,0,0,.421.652.652,0,0,0,.335.286,6.867,6.867,0,0,0,9.3-3.434c.572-1.3.792-2.861,1.926-3.7a.964.964,0,0,1,.461-.209,1.347,1.347,0,0,1,.744.249,7.327,7.327,0,0,0,4.893.492,4.548,4.548,0,0,0,2.658-1.322c1.29-1.534.572-3.825.658-5.825.069-1.6.684-3.288,0-4.735-.773-1.654-3.042-2.484-3.23-4.292-.114-1.082.589-2.063.9-3.1.741-2.5-.8-5.044-2.269-7.193a9.962,9.962,0,0,0-1.8-2.16,8.639,8.639,0,0,0-2.163-1.2A52.868,52.868,0,0,0,705.1,181.9,9.961,9.961,0,0,0,698.819,181.748Z",
    transform: "translate(-516.968 -147.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M733.232,256.192H725.65V243.905a22.892,22.892,0,0,0,.395-3.577V239.1a6.326,6.326,0,0,0-1.17-3.82c-2.092-2.352,6.8-1.96,6.8-1.96a22.119,22.119,0,0,0,1.059,3.165,19.245,19.245,0,0,0,2.547,4.484,10.374,10.374,0,0,0,3.454,2.939C743.948,246.521,733.232,256.192,733.232,256.192Z",
    transform: "translate(-540.437 -184.812)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(184.11 48.482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732.7,236.483a6.938,6.938,0,0,1-6.684,2.615,6.325,6.325,0,0,0-1.17-3.82c-2.091-2.352,6.8-1.96,6.8-1.96A22.134,22.134,0,0,0,732.7,236.483Z",
    transform: "translate(-724.526 -233.294)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 6.927,
    cy: 6.927,
    r: 6.927,
    transform: "translate(179.854 40.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M797.485,249.478a41.2,41.2,0,0,0-.652,5.488c-.106,2.355-1.782,10.893-2.395,13.94a2.418,2.418,0,0,1-1.448,1.765c-1.7.7-4.79,1.084-6.867-3.811a54.192,54.192,0,0,1-2.841-8.326,22.488,22.488,0,0,1-.572-2.913l4.578-2.484a5.641,5.641,0,0,1,1.082,1.388,9.281,9.281,0,0,1,1.144,5.276l1.431,2.092s3.528-10.979,2.861-12.939,2.092-2.484,2.092-2.484,7.711-6.009,8.627-5.1S801.8,246.862,797.485,249.478Z",
    transform: "translate(-581.952 -190.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M656.227,245.389a30.883,30.883,0,0,1-1.23,3c-1.539,3.31-4.555,8.584-9.225,11.634-7.187,4.7-5.62-4.835-5.62-4.835s1.76-11.342,2.092-12.415a13.563,13.563,0,0,0,.26-4.312c-2.744-1.308-5.88-9.539-4.967-10.195s7.439,6.927,7.439,6.927,3.007,1.431,1.431,3.791-.916,12.807-.916,12.807l3.024-4.175a20.856,20.856,0,0,1,2.687-4.887c.572-.781.973-1.253.973-1.253Z",
    transform: "translate(-478.201 -181.196)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(200.752 62.621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.358,284.1c-.961.355-4.684,1.857-5.1,4.006a22.509,22.509,0,0,1-.572-2.913l4.578-2.484A5.642,5.642,0,0,1,788.358,284.1Z",
    transform: "translate(-782.69 -282.71)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(173.001 60.275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690.724,278.427a30.915,30.915,0,0,1-1.23,3c-.177-1.293-.907-4.6-3.794-5.668.572-.781.973-1.253.973-1.253Z",
    transform: "translate(-685.7 -274.51)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(185.213 55.517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M735.962,273.743H728.38V261.457a22.893,22.893,0,0,0,.395-3.577,4.715,4.715,0,0,1,1.173,3.837L734,270.873l1.963-8.094-.652-1.044,2.69-3.2a10.375,10.375,0,0,0,3.454,2.938C746.678,264.072,735.962,273.743,735.962,273.743Z",
    transform: "translate(-728.38 -257.88)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(172.807 91.889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.365,389.578s-5.94-.472-11.093-.7l-.518-.023c-.732-.029-1.431-.051-2.115-.069a47.358,47.358,0,0,1-11.619-2.175A19.081,19.081,0,0,1,686.187,385l7.843,1.717s1.236.395,3.983,1.611L693.506,385l13.734,2.484s.478-.06,3,1.353Z",
    transform: "translate(-685.02 -385)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M704.659,263.258l-.652-1.044,2.9-3.471s5.983,2.933,7.551,2.289c0,0,3.791,3.147,3.92,4.967,0,0-5.488,1.828-5.359,4.578s-2.6,8.624-2.6,8.624l-1.144,4.7a20.912,20.912,0,0,0-.286,8.7l1.044,5.817s-8.235-.652-13.734-.784a47.629,47.629,0,0,1-11.762-2.22l3.207-6.75a17.167,17.167,0,0,0,1.654-7.805l-.286-10.927s-.26-5.488-4.578-6.4c0,0,2.352-4.835,6.009-4.444,0,0,5.328-2.223,6.91-.721a4.708,4.708,0,0,1,1.193,3.857l4.052,9.156Z",
    transform: "translate(-511.864 -202.334)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(179.843 37.096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M711.552,202.05c1.05,0,1.874-1.113,2.924-1.056a2.98,2.98,0,0,1,1.459.687,17.81,17.81,0,0,0,5.582,2.575,4.87,4.87,0,0,0,2.375.172,2.025,2.025,0,0,0,1.6-1.6,2.724,2.724,0,0,0-.137-1.039,12.838,12.838,0,0,0-5.591-7.379,4.4,4.4,0,0,0-3.619-.758,7.176,7.176,0,0,0-2.575,2.232,9.789,9.789,0,0,1-2,1.625c-.572.346-1.431.572-1.76,1.207C709.183,199.9,710.159,202.038,711.552,202.05Z",
    transform: "translate(-709.613 -193.5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M711.552,201.14c1.05,0,1.874-1.113,2.924-1.056a2.98,2.98,0,0,1,1.459.687,17.81,17.81,0,0,0,5.582,2.575,4.87,4.87,0,0,0,2.375.172,2.025,2.025,0,0,0,1.6-1.6,2.724,2.724,0,0,0-.137-1.039,12.838,12.838,0,0,0-5.591-7.379,4.4,4.4,0,0,0-3.619-.758,7.176,7.176,0,0,0-2.575,2.232,9.791,9.791,0,0,1-2,1.625c-.572.346-1.431.572-1.76,1.207C709.183,199,710.159,201.125,711.552,201.14Z",
    transform: "translate(-529.77 -155.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M705.32,326.79s6.4,2.352,10.587.524l2.092.132s3.476,2.438,7.153,1.348",
    transform: "translate(-526.705 -251.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M809.621,313.09s-1.044,2.484-.524,3.268",
    transform: "translate(-600.685 -241.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M665.58,310.35s.523,2.484,0,3.268",
    transform: "translate(-498.336 -239.82)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIllustration);
export default __webpack_public_path__ + "static/media/clock_illustration.75a8a000e967c22bb1697d5470e951c4.svg";
export { ForwardRef as ReactComponent };